enum EnergyEfficiencyClassMediaEnum {
	svg = '00017',
	jpeg = '00001'
}

export default EnergyEfficiencyClassMediaEnum;
